import { observable, action, computed } from 'mobx';
import fetchDataHelper from '../helpers/fetchDataHelper';

export interface IUserStore {
    inProgress: boolean;
    errors: string[];
    userNameField:string;
	passwordField: string;
    userName: string;   
	isAdmin: boolean;
    redirectUrl: string;
    setUserNameField(userName: string): void;
    setPasswordField(password: string): void;
    clearRedirectUrl(): void;
    resetFields(): void;
    login(): any;
    logout(): any;
}

class UserStore implements IUserStore {
	@observable inProgress: boolean = false;
	@observable errors: string[] =  undefined;
	@observable userNameField: string = '';
	@observable passwordField: string = '';
	@observable redirectUrl: string = '';

	@action setUserNameField(userName: string): void {
		this.userNameField = userName;
	}
	
	@action setPasswordField(password: string): void {
		this.passwordField = password;
	}

	@computed get userName(): string {
		return window.localStorage.getItem('userName');
	}

	@computed get isAdmin(): boolean {
		return window.localStorage.getItem('isAdmin') == 'true';
	}

	@action resetFields(): void {
		this.userNameField = '';
		this.passwordField = '';
	}

	@action.bound clearRedirectUrl(): void {
		this.redirectUrl = undefined;
	}

	@action login(): Promise<void> {
		this.inProgress = true;
		this.errors = undefined;

		return fetchDataHelper.postReturnJson("/user/login", {userName: this.userNameField, password: this.passwordField}, true)
		.then(
			(result) => {
				window.localStorage.setItem('jwt', result.jwtToken);
				window.localStorage.setItem('refresh', result.refreshToken);
				window.localStorage.setItem('userName', result.userName);
				window.localStorage.setItem('isAdmin', result.isAdmin);
				
				this.redirectUrl = '/';
				this.inProgress = false;
				return Promise.resolve();
			},
			(error) => {
				this.errors = [error + ''];
				this.inProgress = false;
				return Promise.resolve();
			}
		);
	} 
	
	@action.bound logout() {

		var userName = window.localStorage.getItem('userName');
		var token = window.localStorage.getItem('refresh');		

		fetchDataHelper.post("/user/revokeToken", { userName, token })
			.then(
				() => { 
					this.clearLocalStorage();
					this.redirectUrl = '/login';
				},
				() => { 
					this.clearLocalStorage();
					this.redirectUrl = '/login';
				});
	}

	@action.bound logoutNoRevoke() {
		this.clearLocalStorage();
		this.redirectUrl = '/login';
	}

	@action.bound refreshToken(): Promise<void> {
		var userName = window.localStorage.getItem('userName');
		var token = window.localStorage.getItem('refresh');

		return fetchDataHelper.postReturnJson("/user/refreshToken", { userName, token }, true)
		.then(
			(result) => {	
				window.localStorage.setItem('jwt', result.jwtToken);
				window.localStorage.setItem('refresh', result.refreshToken);
				
				return Promise.resolve();
			},
			() => {
				this.logoutNoRevoke();
				return Promise.reject();
			}
		);
	}

	clearLocalStorage(): void {
		window.localStorage.removeItem('jwt');
		window.localStorage.removeItem('userName');
		window.localStorage.removeItem('isAdmin');
		window.localStorage.removeItem('refresh');
	}
}

export default new UserStore();